import date from 'date-and-time';
import { platformMeta } from './platformMeta';
import { SerializedSocialChannel } from './types';

/** Local midnight of the day after `now`. */
export function nextDayFrom(now: Date): Date {
  return date.addDays(new Date(now.getFullYear(), now.getMonth(), now.getDate()), 1);
}

/**
 * When the first post on a channel goes out.
 *
 * A learned slot wins. Nothing learns one yet, so in practice this is the
 * platform's default hour, in the artist's own timezone — a defensible guess
 * we say out loud in the plan summary rather than dressing up as data.
 */
export function channelSlot(channel: SerializedSocialChannel, now: Date): Date {
  const day = nextDayFrom(now);

  if (channel.bestTimeUtc !== null && channel.bestTimeUtc !== '') {
    const [hours, minutes] = channel.bestTimeUtc.split(':').map((part) => Number(part));
    const slot = new Date(day);
    slot.setUTCHours(
      hours === undefined || Number.isNaN(hours) ? 12 : hours,
      minutes === undefined || Number.isNaN(minutes) ? 0 : minutes,
      0,
      0
    );
    // A UTC hour can land the slot back in today once the offset is applied.
    return slot.getTime() <= now.getTime() ? date.addDays(slot, 1) : slot;
  }

  return date.addHours(day, platformMeta[channel.platform].defaultHour);
}
